import axios from 'axios'

const UNAUTHORIZED_STATUSES = [401, 403]

// Ошибка fetchAuth не про авторизацию: сеть, таймаут, 5xx. Не-сетевая ошибка
// (нет токена) и 401/403 — бэк отверг токен, юзер не авторизован
export const isAuthUnavailable = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) {
    return false
  }

  const status = error.response?.status ?? null

  return status === null || !UNAUTHORIZED_STATUSES.includes(status)
}
